module.exports = __webpack_public_path__ + "img/Union.d27dd25e.svg";